<div class="">
    <div class="col-12 p-0 exprx--common-block erx--body insurance--body patient-edit--transfer-in my-0">
        <div class="eprx--block__header text-white pl-3 font-weight-bold" *ngIf="!IsFullscreenMode">
            <div class="transfer_details">
                <div class="left_display">
                    <div>Transfer Request Details</div>
                    <div class="count_display">
                        <span class="font-weight-bold color_green">Transferable Rx(s) : </span> 
                        <span class="font-weight-bold color_green">{{rxList?.TransferableRx?.length ? rxList?.TransferableRx?.length :
                            0}}</span>
                    </div>
                    <div class="count_display" container="body" [ngbTooltip]="'When no quantity is left, Rx(s) can be transferred electronically as Informational Rx(s).'" tooltipClass="common-tooltip"
                    triggers="mouseover:mouseleave" placement="top">
                        <span class="font-weight-bold  unavailable">Informational Rx(s) : </span> 
                        <span class="font-weight-bold unavailable">{{rxList?.NonTransferableRx?.length ? rxList?.NonTransferableRx?.length :
                            0}}</span>
                    </div>
                </div>
                <div class="right_display">
                    <div>
                        <span class="rx--filter_text">
                            <button type="button" class="submit print-med-guide background_orange_RGB border_1px_solid_black"
                                (click)="toggleColorLegend()">Color Legend</button>
                        </span>
                    </div>
                    <div *ngIf="!IsTransferType && !IsFromXfroutInfo">
                        <button class="hotkey_success show_originalReq" (click)="getDetails()"
                        [ngbTooltip]="'Transfer Request Info'"  tooltipClass="common-tooltip" triggers="mouseover:mouseleave" placement="top">Transfer Request Info</button>
                    </div>
                    <div>
                        <i   [ngbTooltip]="'Full Screen View for Informational Rx(s) & Transferable Rx(s)'"  tooltipClass="common-tooltip" triggers="mouseover:mouseleave" placement="left"   id="fullScreen" (click)="showFullScreen()" *ngIf="!IsFullscreenMode"
                            class="fa fa-window-maximize font_icon text-white icon_postions font-size_2_2"></i>
                    </div>
                </div>
              </div>
        </div>
        <div class="px-0 pt-0" [ngClass] = "IsFullscreenMode? '' : 'eprx--block__content p-2'">
            <!--To display Transferrable and Informational Rxs in the grid view-->
            <div>
                <wj-flex-grid #TransferrableWJ [headersVisibility]="'Column'" [itemsSource]="transferrableWJ"
                    [isReadOnly]="true"  [itemFormatter]="itemFormatter" 
                     (initialized)="init(TransferrableWJ)" [columnPicker]="'RxsTransferIn'"
                    id="transferrableNonRxs" [selectionMode]="'Row'" [allowSorting]="true"
                    [ngClass]="[!(rxList?.TransferableRx?.length || rxList?.NonTransferableRx?.length)? 'no-data default-minmaxheight-transfer': (!IsFullscreenMode? 'wijmo_transfer_in' : '')]">
                    <wj-flex-grid-column header="" [width]="34" [minWidth]="30" *ngIf="!IsFromXfroutInfo">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item" let-cell="cell">
                            <span class="text-center">
                                <input class="form-check-input checkbox_center" type="checkbox" [id]="'check'+ item.row" name="" [(ngModel)]="item.IsSelected"
                                    [checked]="item.IsSelected" (click)="selectedItems(item)">
                                <label class="form-check-label" [for]="'check'+ item.row">
                                </label>
                            </span>
                        </ng-template>
                    </wj-flex-grid-column> 
                    <wj-flex-grid-column [header]="rxheader['hName']" [binding]="rxheader['hName']"
                        [visible]="rxheader['isVisible']"  [width]="rxheader['width']" [minWidth]="rxheader['minWidth']" 
                        *ngFor="let rxheader of wjHeaders; let i = index">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item" let-row="row">
                            <div *ngIf="rxheader['hName']==='Prescriber Name'" [ngbTooltip]=preToolTipInfo  placement="left" triggers="mouseenter:mouseleave" container="body"
                            container="body" [openDelay]="500" tooltipClass="erx-prescriber-tooltip">
                            <span class="float-left" *ngIf="rxheader['hName'] === 'Prescriber Name'">
                            <i title="Edit" *ngIf="!IsFromXfroutInfo" class="far fa-edit actions" (click)="editPrescriber(item,'EditPrescriber')"></i>
                            {{ item[rxheader['hName']] }} 
                            </span>
                                <ng-template #preToolTipInfo>
                                    <div>
                                        <div class="row text-left">
                                            <div class="col-md-12">
                                                <label class="text-decoration-underline margin_bottom_1rem">Prescriber Info</label>
                                            </div>
                                            <div class="col-md-6">
                                                <label>NPI# : </label>
                                                <span> {{item["NPI#"]}}</span>
                                            </div>
                                            <div class="col-md-6">
                                                <label>DEA# : </label>
                                                <span> {{item["DEA#"] | uppercase}}</span>
                                            </div>
                                            <div class="col-md-6">
                                                <label>Telephone# : </label>
                                                <span> {{item["PrescriberInfo"] && item["PrescriberInfo"]['Telephone'] ? (["PrescriberInfo"]['Telephone'] | mask : "(000)000-0000") : ''}}</span>
                                            </div>
                                            <div class="col-md-6">
                                                <label>Fax# : </label>
                                                <span> {{item["PrescriberInfo"] && item["PrescriberInfo"]['Fax'] ? (["PrescriberInfo"]['Fax'] | mask : "(000)000-0000") : ''}}</span>
                                            </div>
                                            <div class="col-md-12">
                                                <label>Address : </label>
                                                <span> {{item["PrescriberAddress"] | uppercase}}</span>
                                            </div>
                                        </div>
                                    </div>
                            </ng-template>
                            </div>
                            <div *ngIf="rxheader['hName'] !=='Prescriber Name' && rxheader['hName'] !=='Transfer Mode'">
                                {{ item[rxheader['hName']] }}
                            </div>
                            <div *ngIf=" rxheader['hName'] ==='Transfer Mode'">
                               <eprx-select [LabelText]="''" [ShowDefaultValue]="true" [IsTransferMode]="true" [List]="transferModes"[HasControl]="false" [cssStyle]="true" [IsAppendTo]="true"  [Title]="(item.IsElectronic === 1 ? 'Fax' : (item.IsElectronic === 2 ? 'Electronic' : 'Informational Rx'))" 
                                [BindValue]="'name'" [forFileGenerate]="true" [IsDisabled]="item.IsFaxDisabled" [BindLabel]="'name'" [LabelForId]="'TransferMode'" [InputValue]="(item.IsElectronic === 1 ? 'Fax' : (item.IsElectronic === 2 ? 'Electronic' : 'Informational Rx'))" 
                                [CheckIsElectronic]="item.IsElectronic" (TriggerSelectValue)="getTransferMode($event, item)">
                              </eprx-select>
                            </div>
                        </ng-template>
                        <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-item="item">
                            <div title={{rxheader.hName}}>
                                {{ rxheader.hName }}
                            </div>
                        </ng-template>
                    </wj-flex-grid-column>
                    <app-no-data-found *ngIf="!isDataExists1" [IsPageFrm]="'TransferOut'"></app-no-data-found>
                </wj-flex-grid>
            </div>
            <div *ngIf="IsFullscreenMode" class="d-flex mt-2">
                 <div>
                    <span>Transferable Rx(s) : </span> 
                    <span>{{rxList?.TransferableRx?.length ? rxList?.TransferableRx?.length :0}}</span>
                </div> &nbsp;&nbsp;
                <div>
                    <span>Informational Rx(s) : </span> 
                    <span>{{rxList?.NonTransferableRx?.length ? rxList?.NonTransferableRx?.length :0}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<app-transfer-in *ngIf="IseRxTRxREQ"  (ClosePopUpModal)="IseRxTRxREQ=false" [AwaitInfo]="awaitInfo" [currentDetails]="currentDetails"> </app-transfer-in>


<ng-template #ConfirmMesgBeforeTransferOut let-c="close" let-d="dismiss" class="el--popup">
    <div class="modal-header">
        <h4 class="modal-title">{{PopupHeader}}</h4>
    </div>
    <div class="modal-body" >
        <label class="align-label">Rx#: </label> {{transfData?.Prescription?.PrescNum}}-{{transfData?.PrescReFill?.ReFillNum}}<span *ngIf="_commonServ?.checkIsPartialFill(transfData?.PrescReFill, transfData?.Prescription)">-{{transfData?.PrescReFill?.PartialFillNo}}
        </span>
    &nbsp;
        <label class="align-label">Date Filled:</label>
        <span class="word-break col px-2">{{transfData?.PrescReFill?.FillDtTm | date:'MM/dd/yyyy'}}</span>
        <br>
        <label class="align-label"> Drug Name:</label>
        {{ _formatsUtil.displaytallmanlettering(transfData?.Drug, true) }}
        <br>
            <label class="align-label"> Patient Name:</label>
            <span class="word-break col px-2">{{transfData?.Patient?.lastname | uppercase}},&nbsp;{{transfData?.Patient?.firstname | uppercase}}</span>   
                     
            <p class="mt-4" [innerHTML]="isPickup?.messages">   </p>
            <div class="mt-4" *ngIf="isPickup.IsOk && !isPickup?.messages">
                <div class="mb-2">The following Rx(s) are not picked up by the patient:</div>
                 <div *ngIf="transferRefillDifferList?.length">
                    <b>Deferred Rx(s): </b><span *ngFor="let item of transferRefillDifferList; let last = last">
                        <label class="font_weight_500">{{ item }}</label><span *ngIf="!last">, </span></span>
                </div>
                <div *ngIf="transferRefillUnbilledList?.length">
                    <b>Unbilled Rx(s): </b><span *ngFor="let item of transferRefillUnbilledList; let last = last">
                        <label class="font_weight_500">{{ item }}</label><span *ngIf="!last">, </span></span>
                </div>
                <div class="mt-2">These refill(s) will also be transferred out along with the selected prescription.</div>
            </div>
            <div class="mt-4" *ngIf="isPickup.ManualReversal && isPickup.TransferNext && !isPickup.messages">
                <div class="mb-2">The following Rx(s) are not picked up by the patient:</div>
                 <div *ngIf="reverseRefillList?.length">
                    <b>Billed Rx(s): </b><span *ngFor="let item of reverseRefillList; let last = last">
                    <label class="font_weight_500">{{ item }}</label><span *ngIf="!last">, </span></span>
                </div>
                <div class="mt-2">To transfer the unpicked refill(s), please reverse it first and then transfer.</div>
            </div>
            

    </div>
        <div class="modal-footer" *ngIf="isPickup.ManualReversal && isPickup.TransferNext">
        <button class="hotkey_primary" ngbAutofocus appShortcutKey InputKey ="m"
        (click)="closePopUp();c('Close click')" [ngbTooltip]="'Manually reverse the Billed and Unpicked refill(s) of the prescription and then transfer out.'"  triggers="mouseover:mouseleave"[autoClose]="true" placement="top"
                        tooltipClass="title-tooltip_transfer" ><b>m</b>Manually Reverse and Transfer</button>
        <button class="hotkey_primary" appShortcutKey InputKey ="n"
      (click)="IsPickOrUnPick(true); c('Close click')"   [ngbTooltip]="isPickup?.RxRefillTransferOut ? 'Remaining Refill(s) will be transferred out.' : 'New Refill will be transferred out.'"  triggers="mouseover:mouseleave"[autoClose]="true" placement="left"
                        tooltipClass="title-tooltip_transfer"><b>n</b>Transfer Next</button>
    </div>
    <div class="modal-footer" *ngIf="isPickup.IsConfirm && !isPickup.IsWarn">
        <button class="hotkey_primary" ngbAutofocus appShortcutKey InputKey ="y"
        (click)="IsPickOrUnPick(true);c('Close click')"><b>y</b>YES</button>
        <button class="hotkey_primary" appShortcutKey InputKey ="n"
      (click)="IsPickOrUnPick(false); c('Close click')"><b>n</b>NO</button>      
    </div>
    <div class="modal-footer" *ngIf="isPickup.IsOk">
        <button class="hotkey_primary" ngbAutofocus appShortcutKey InputKey ="o"
        (click)="c('Close click')"><b>o</b>OK</button>
    </div>
</ng-template>